<template>
  <div>
    <Loading v-if="loading" />

    <v-container v-else class="py-10 py-sm-12 py-md-14 py-lg-16">
      <PagesTitle logoHeight="24px" :mod="mod">Certificações</PagesTitle>

      <v-row
        class="mt-8"
        align="center"
        v-for="({ title, img, text }, keyItems) in items"
        :key="keyItems"
      >
        <v-col cols="12" md="6">
          <div class="text-h5 text-md-h4 font-weight-bold cert-title">
            {{ title }}
          </div>
          <div v-if="text" v-html="text" class="secondary--text"></div>
        </v-col>
        <v-col cols="12" md="6">
          <img
            v-for="img in img.list"
            :key="img.path"
            :src="files + img.path"
            class="cert-img"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PagesTitle from "../widgets/PagesTitle.vue";
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-certifications",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    items: [],
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.items = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style scoped>
.cert-img {
  max-width: 100%;
  height: auto;
}
</style>
